var _defs, _ellipse, _rect, _circle, _circle2, _circle3, _rect2, _polygon, _rect3, _polygon2, _rect4, _rect5, _rect6, _rect7, _circle4, _rect8, _rect9, _rect10, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyLanded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "w2",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r2",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D2FA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A1F80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE9A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC98A"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 204,
    rx: 140,
    ry: 12,
    fill: "rgba(20,10,80,.3)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 188,
    width: 272,
    height: 12,
    rx: 6,
    fill: "#7CD6A8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 168,
    r: 20,
    fill: "#4FBF8B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 178,
    r: 14,
    fill: "#6ED3A0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 172,
    r: 16,
    fill: "#4FBF8B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 86,
    width: 136,
    height: 104,
    fill: "url(#w2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "48,90 128,38 208,90",
    fill: "url(#r2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 116,
    width: 70,
    height: 74,
    fill: "url(#w2)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "188,120 231,94 274,120",
    fill: "url(#r2)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 102,
    width: 38,
    height: 26,
    rx: 3,
    fill: "url(#g2)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 102,
    width: 38,
    height: 26,
    rx: 3,
    fill: "url(#g2)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 132,
    width: 112,
    height: 4,
    fill: "#C9C1F5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 146,
    width: 28,
    height: 44,
    rx: 3,
    fill: "#6C5CE7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 168,
    r: 2,
    fill: "#FFE58F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 150,
    width: 30,
    height: 24,
    rx: 3,
    fill: "url(#g2)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 150,
    width: 30,
    height: 24,
    rx: 3,
    fill: "url(#g2)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 144,
    width: 50,
    height: 46,
    rx: 3,
    fill: "#D9D3FB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 206,
    y1: 156,
    x2: 256,
    y2: 156,
    stroke: "#C3BAF5",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 206,
    y1: 168,
    x2: 256,
    y2: 168,
    stroke: "#C3BAF5",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 206,
    y1: 180,
    x2: 256,
    y2: 180,
    stroke: "#C3BAF5",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyLanded);
export default __webpack_public_path__ + "static/media/property-landed.40f9529c9460d3163cb2c273a6ae0756.svg";
export { ForwardRef as ReactComponent };